// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-X1X","label":"styles_label__2YGCH"};